import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import { ArrowRightIcon } from "assets/icons";
import { OverlayLoading } from "components";
import { useBookTicketMutation } from "../../redux/services/bookingServices";
import {
  resetBookingStates,
  setOpenPaymentProcessModal,
} from "../../redux/reducers/bookingReducer";

function Ticket({ setActiveStep, busDetail, booking }) {
  const dispatch = useDispatch();
  const navigate = useNavigate;
  const [submitLogin, response] = useBookTicketMutation();
  const { isError, isLoading, isSuccess, data, error } = response;

  const totalPassengers = booking?.passengerData?.length || 0;
  const price = busDetail?.bus_rate * totalPassengers;
  const boardingPassAmount = booking?.boarding_pass_price * totalPassengers;
  const travelProtectionAmount =
    booking?.travel_protection_price * totalPassengers;
  const totalAmount = price + boardingPassAmount + travelProtectionAmount;

  useEffect(() => {
    if (!isLoading && isSuccess) {
      window.open(data?.link, "_blank");
      dispatch(resetBookingStates());
      dispatch(setOpenPaymentProcessModal(true));
    }
    if (isError) {
      toast.error(error.data?.message);
    }
  }, [response]);

  const handleSubmit = async () => {
    const updatedPassengerData = booking?.passengerData.map(
      ({ seat_type, ...rest }) => rest
    );

    let data = {
      total: totalAmount.toString(),
      wall_amt: "0",
      source: "mobile",
      name: booking.passengerData?.length
        ? booking.passengerData[0].name
        : null,
      email: booking.email,
      ccode: "+60",
      mobile: booking.mobile,
      uid: 4,
      payment_method_id: 7,
      tickets: [
        {
          operator_id: busDetail?.operator_id,
          bus_id: busDetail?.bus_id,
          pickup_id: busDetail?.id_pickup_drop,
          drop_id: busDetail?.id_pickup_drop,
          book_date: busDetail?.trip_date,
          total_seat: busDetail?.totl_seat,
          boarding_city: busDetail?.boarding_city,
          drop_city: busDetail?.drop_city,
          ticket_price: busDetail?.ticket_price,
          bus_picktime: busDetail?.bus_picktime,
          bus_droptime: busDetail?.bus_droptime,
          Difference_pick_drop: busDetail?.Difference_pick_drop,
          sub_pick_time: "",
          sub_pick_place: "",
          sub_pick_address: "",
          sub_pick_mobile: "",
          sub_drop_time: "",
          sub_drop_place: "",
          sub_drop_address: "",
          user_type: "USER",
          total: totalAmount.toString(),
          subtotal: totalAmount.toString(),
          tax_amt: "0",
          tax: "0",
          cou_amt: "0",
          wall_amt: "0",
          commission: "0",
          comm_per: 0,
          PessengerData: updatedPassengerData || [],
        },
      ],
    };

    submitLogin(data);
  };

  return (
    <>
      {isLoading && <OverlayLoading />}
      <div className="w-full bg-white shadow-cityCard py-8 px-6 rounded-[12px]">
        <img src="/images/logo.jpeg" className="h-[54px] mb-6" />
        <div className="text-base md:text-lg font-semibold text-[#112211] mb-6">
          {busDetail?.bus_no}
        </div>
        <div className="w-full max-w-[350px] flex flex-col gap-3">
          <div className="w-full flex items-center justify-between gap-2">
            <div className="text-sm sm:text-base font-medium text-black">
              {busDetail?.boarding_city}
            </div>
            <div className="text-sm sm:text-base font-medium text-black">
              {busDetail?.drop_city}
            </div>
          </div>
          <div className="w-full flex items-center justify-between gap-2">
            <div className="text-sm sm:text-base font-medium text-black">
              {busDetail?.bus_picktime}
            </div>
            <span className="h-3 sm:h-4 w-3 sm:w-4">
              <ArrowRightIcon />
            </span>
            <div className="text-sm sm:text-base text-end font-medium text-black min-w-[140px]">
              {busDetail?.bus_droptime}
            </div>
          </div>
          <div className="w-full flex items-center justify-between gap-2">
            <div className="flex flex-col gap-1">
              <div className="text-sm sm:text-base sm:leading-5 font-medium text-[#63767E]">
                Date of Journey
              </div>
              <div className="text-sm sm:text-base sm:leading-5 font-medium text-[#263238]">
                {busDetail?.trip_date}
              </div>
            </div>
          </div>
        </div>
        <div className="w-full h-[0.5px] bg-[#C4C4C480] my-6" />

        <div className="w-full flex flex-col md:flex-row gap-10 md:gap-[220px]">
          <div className="flex-1 sm:max-w-[400px] flex flex-col gap-4">
            <div className="text-sm sm:text-base text-[#112211] font-bold">
              Passenger Details
            </div>
            {booking.passengerData.map((item, index) => (
              <>
                <div key={index} className="w-full flex flex-col gap-4">
                  <div className="w-full flex items-center justify-between">
                    <div className="text-sm sm:text-base text-[#112211] font-medium">
                      Name
                    </div>
                    <div className="text-sm sm:text-base text-[#112211] font-medium">
                      {item.name}
                    </div>
                  </div>
                  <div className="w-full flex items-center justify-between">
                    <div className="text-sm sm:text-base text-[#112211] font-medium">
                      Age
                    </div>
                    <div className="text-sm sm:text-base text-[#112211] font-medium">
                      {item.age}
                    </div>
                  </div>
                  <div className="w-full flex items-center justify-between">
                    <div className="text-sm sm:text-base text-[#112211] font-medium">
                      Seat
                    </div>
                    <div className="text-sm sm:text-base text-[#112211] font-medium">
                      {item.seat_no}{" "}
                      <span className="capitalize">({item.seat_type})</span>
                    </div>
                  </div>
                </div>
                {index + 2 > booking.passengerData?.length ? null : (
                  <div className="w-full h-[0.5px] bg-[#C4C4C480]" />
                )}
              </>
            ))}
          </div>
          <div className="flex-1 sm:max-w-[400px] flex flex-col gap-4">
            <div className="text-sm sm:text-base text-[#112211] font-bold">
              Contact Info
            </div>
            <div className="w-full flex items-center justify-between">
              <div className="text-sm sm:text-base text-[#112211] font-medium">
                Contact No
              </div>
              <div className="text-sm sm:text-base text-[#112211] font-medium">
                {booking?.mobile}
              </div>
            </div>
            <div className="w-full flex items-center justify-between">
              <div className="text-sm sm:text-base text-[#112211] font-medium">
                Email
              </div>
              <div className="text-sm sm:text-base text-[#112211] font-medium">
                {booking?.email}
              </div>
            </div>
          </div>
        </div>

        <div className="w-full h-[0.5px] bg-[#C4C4C480] my-6" />

        <div className="flex-1 flex flex-col gap-4">
          <div className="text-sm sm:text-base text-[#112211] font-bold">
            Price Details
          </div>
          <div className="w-full flex items-center justify-between">
            <div className="text-sm sm:text-base text-[#112211] font-medium">
              Price
            </div>
            <div className="text-sm sm:text-base text-[#112211] font-medium">
              RM {price}
            </div>
          </div>
          <div className="w-full flex items-center justify-between">
            <div className="text-sm sm:text-base text-[#112211] font-medium">
              Boarding Pass
            </div>
            <div className="text-sm sm:text-base text-[#112211] font-medium">
              RM {boardingPassAmount}
            </div>
          </div>
          <div className="w-full flex items-center justify-between">
            <div className="text-sm sm:text-base text-[#112211] font-medium">
              Travel Protection
            </div>
            <div className="text-sm sm:text-base text-[#112211] font-medium">
              RM {travelProtectionAmount}
            </div>
          </div>
          <div className="w-full flex items-center justify-between">
            <div className="text-sm sm:text-base text-[#112211] font-medium">
              Voucher Applied
            </div>
            <div className="text-sm sm:text-base text-[#112211] font-medium">
              RM 0.00
            </div>
          </div>
        </div>

        <div className="w-full h-[0.5px] bg-[#C4C4C480] my-6" />
        <div className="w-full flex items-center justify-between mb-6">
          <div className="text-base sm:text-lg text-[#112211] font-semibold">
            Total
          </div>
          <div className="text-base sm:text-lg text-[#112211] font-semibold">
            RM {totalAmount}
          </div>
        </div>

        <button
          onClick={handleSubmit}
          className="w-full h-[48px] px-4 py-3 bg-primary-700 flex items-center justify-center rounded-[4px] text-sm font-semibold text-white"
        >
          Pay Now
        </button>
      </div>
    </>
  );
}

export default Ticket;
